import { fileshubPreviewNotSupportedError } from '../../strings.locstring.json';
import loc from 'owa-localize';
import handleSetViewStateFailure from './handleSetViewStateFailure';
import setViewStateForImagePreview from './setViewStateForImagePreview';
import setViewStateForIframePreview from './setViewStateForIframePreview';
import setViewStateForTextPreview from './setViewStateForTextPreview';
import setViewStateForWacPreview from './setViewStateForWacPreview';
import {
    FileExtensionTypes,
    FilePreviewUrl,
    getFilesPreviewInformationStore,
    getSxSViewStore,
    SharePointFilePreviewMethod,
    SharePointFileViewState,
    TextContent,
    PREFETCH_VALID_TIME_IN_MILLISECOND,
} from 'owa-group-files-hub-store';
import { PerformanceDatapoint } from 'owa-analytics';
import { lazySetPreviewLoading, SxSViewState, PreviewPaneViewStateBase } from 'owa-sxsdata';

export const imagePreviewSize: number = 1024;

export default async function previewSharePointFileInNewSxS(
    fileViewState: SharePointFileViewState
) {
    const store = getSxSViewStore();
    const optionalParameters = {
        downloadUrl: fileViewState.downloadUrl,
        downloadShouldOpenNewTab: true,
        useHighContrastCommandBar: false,
        id: fileViewState.id,
    };

    await setViewState(fileViewState, optionalParameters, store.datapoint);
}

async function setViewState(
    fileViewState: SharePointFileViewState,
    optionalParameters: PreviewPaneViewStateBase,
    datapoint: PerformanceDatapoint
) {
    datapoint.addCustomProperty('fileType', FileExtensionTypes[fileViewState.fileExtensionType]);
    const previewInformationStore = getFilesPreviewInformationStore();
    let previewInformation;
    // Image preview url is returned from GetFileItems. Thus we do not prefetch Image preview info.
    if (fileViewState.fileExtensionType != FileExtensionTypes.Image) {
        if (
            previewInformationStore.fileInformation[fileViewState.id] &&
            previewInformationStore.fileInformation[fileViewState.id].previewInformation &&
            previewInformationStore.fileInformation[fileViewState.id].previewInformation
                .lastUpdateTime &&
            new Date().getTime() -
                previewInformationStore.fileInformation[
                    fileViewState.id
                ].previewInformation.lastUpdateTime.getTime() <
                PREFETCH_VALID_TIME_IN_MILLISECOND
        ) {
            const setPreviewLoading = await lazySetPreviewLoading.import();
            const store = getSxSViewStore();
            const sxsViewState: SxSViewState = store.viewState;
            setPreviewLoading(
                sxsViewState,
                '', // loading message. When it is empty we only show a spinner.
                optionalParameters
            );
            datapoint.addCustomProperty('PrefetchSucceeded', true);
            previewInformation =
                previewInformationStore.fileInformation[fileViewState.id].previewInformation;
        } else {
            datapoint.addCustomProperty('PrefetchSucceeded', false);
            if (
                previewInformationStore.fileInformation[fileViewState.id] &&
                previewInformationStore.fileInformation[fileViewState.id].error
            ) {
                datapoint.addCustomProperty(
                    'PrefetchFailureDetails',
                    previewInformationStore.fileInformation[fileViewState.id].error.stack
                );
            }
        }
    }

    switch (fileViewState.strategy.previewMethod) {
        case SharePointFilePreviewMethod.Image:
            await setViewStateForImagePreview(fileViewState, optionalParameters);
            break;
        case SharePointFilePreviewMethod.IFrame:
            await setViewStateForIframePreview(
                previewInformation as FilePreviewUrl,
                fileViewState,
                optionalParameters
            );
            break;
        case SharePointFilePreviewMethod.Text:
            await setViewStateForTextPreview(
                previewInformation as TextContent,
                fileViewState,
                optionalParameters
            );
            break;
        case SharePointFilePreviewMethod.Wac:
            await setViewStateForWacPreview(
                previewInformation as FilePreviewUrl,
                fileViewState,
                optionalParameters
            );
            break;
        default:
            const error = new Error(loc(fileshubPreviewNotSupportedError));
            await handleSetViewStateFailure(error, error.message, datapoint);
    }
}
